import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from "react-redux";
import CheckbookTray from '../components/CheckBook/CheckbookTray'
import Dashboard from '../components/Menu/Dashboard';
import { withRouter } from 'react-router-dom'
import { getCheckbook, getCheckCharge, setEndorse } from './../actions/checkbooks'
import { getCustomerData } from "./../actions/customers";
import { SubmissionError } from 'redux-form';
// import { useStylesTable } from './../components/Complements/usesStyles'
import DialogConfirm from '../components/Complements/DialogConfirm';
import DialogOTP from '../components/Complements/DialogOTP';
import DialogPrompt from '../components/Complements/DialogPrompt';
import CheckBookEndorseForm from '../components/CheckBook/CheckBookEndorseForm';

class CheckbookPayContainer extends Component {
    state = {
        title: 'Acciones',
        subTitle: 'Como desea cobrar el cheque?',
        openDialog: false,
        openDialogOTP: false,
        openDialogPrompt: false,
        openDialogEndorse: false,
        amount: 0,
        selectedDate: '',
        description: '',
        emitidor: {},
        otp: 0,
        owner: '',
        cedule: '',
        imgName: '',
        email: '',
        request: '',
        message: '',
        typeText: 'text',
        type: 'info',
        checkbooks: [] };
    componentDidMount() {
        (this.props.checkbook.length === 0) ? this.fetchCheckbooks(this.props.user.vusk, this.props.PaymentType) :
        this.setState({
            checkbooks: this.props.checkbook
        })
    }
    
    fetchCheckbooks = (cedule, PaymentType) => {
        cedule && this.props.getCheckbook(PaymentType, cedule).then(({payload})=> {
            this.setState({
                checkbooks: payload
            })
        })
    }

    createButton = (name) => {
        return { name }
    }

    handlePayType = (option) => {
        const { amount, selectedDate, emitidor, description } = this.state
        const { cedule } = this.props.devices
        if (option === 'COBRAR') {
            const now = new Date()
            if ( now >  new Date(selectedDate)) {
                
                this.props.getCheckCharge(false, emitidor.cedule, amount, selectedDate, 'CHARGE', cedule, emitidor.email, description).then(r => {
                    if (r.payload) {
                        const {state, result } = r.payload
                        if (state) {
                            // this.fetchCheckbooks(this.props.user.vusk, this.props.PaymentType)
                            this.props.handleOpenSnack(result, 'success')
                        } else {
                            this.props.handleOpenSnack(result, 'error')
                        }
                    }
                })
            } else {
            }
            
            /* this.props.validateOTP(serie, imei, cedule, amount, otp).then( r => {
                // this.setState({  })
                this.setState({  openDialog: false, otp: r.payload.code })
                this.handleOpenDialogOTP()
            }) */
        } else if (option === 'RECHAZAR') {
            this.setState({  openDialogPrompt: true })
        } else if (option === 'ENDOSAR') {
            this.setState({  openDialogEndorse: true })
        }
        
    }

    handleOpenDialog = (data) => {
        return (data.state === '0') && this.setState({ openDialog: true, 
            amount: data.amount, request: data.request, otp: data.otp,
            selectedDate: data.date, emitidor: data.Emitidor, description: data.description, imgName: data.code })
    }

    handleOpenDialogOTP = () => {
      this.setState({ openDialogOTP: true })
    }

    
    
    handleCloseDialog = () => {
      this.setState({ openDialog: false });
    };

    handleCloseDialogOTP = () => {
      this.setState({ openDialogOTP: false });
    };

    handleCloseDialogPrompt = () => {
      this.setState({ openDialogPrompt: false });
    };
    
    handleSubmit = (values) => {
        this.setState({ alert: true })
    }



    receiveOTP = (otp) => {
        const { serie, imei, cedule } = this.props.devices
        return (otp === this.state.otp.toString()) ? 
        this.props.compareOTP(serie, imei, cedule, otp, this.state.request).then(r => {
            this.setState({
                checkbooks: this.props.checkbooks
            })
            this.props.handleOpenSnack('Pago realizado', 'success')
        }) : this.props.handleOpenSnack('Código no válido', 'error')
        

    }

    receivePrompt = (description) => {
        /* const { otp, request } = this.state
        const { cedule } = this.props.devices */

        /* return this.props.setEndorse(cedule, amount, date, serie, imei, emited, emite, email, description, image).then(r => {
            // this.handleOpenSnack('Pago rechazado', 'success')
        }) */
    }

    receiveEndorse = () => {
        const { amount, selectedDate, email,description, imgName } = this.state
        const { cedule } = this.props.devices
        this.props.setEndorse(false, this.state.cedule, amount, selectedDate, 'ENDORSEMENT', cedule, email, description, imgName).then(r => {
            const { alert, type } = r.payload
            this.props.handleOpenSnack(alert, type)
        }).catch(err => {/* console.log('error de comunidacion ', err) */})
    }
    handleCloseDialogEndorse = () => {
      this.setState({ openDialogEndorse: false });
    };

    findCustomer = (value) => {
        const { customers } = this.props
        // let customer = {}
        if (customers.length === 0) {
            this.props.getCustomerData(value).then(r => {
                if (r.error) {
                    throw new SubmissionError(r.payload)
                }
                const { first_name, second_name, surname, second_surname, cedule, email } = r.payload
                let Names = `${first_name} ${second_name} ${surname} ${second_surname}`
                this.setState({ owner: Names, cedule, email })
                // customer = r.payload
            })
        } else {
            const getCustomer = customers.find(customer => customer.cedule === value);
            const { first_name, second_name, surname, second_surname, cedule, email } = getCustomer
                let Names = `${first_name} ${second_name} ${surname} ${second_surname}`
            this.setState({ owner: Names, cedule, email })
        }
        // return customer
    }

    
    renderBody = () => {
        return <div>
                    <CheckbookTray
                        {...this.props}
                        classes = { this.props }
                        typeRequest = 'Payment'
                        paymentsData = { this.props.checkbook }
                        handleOpenDialog= { this.handleOpenDialog }
                        // handleSubmit={ this.handleSubmit }
                    />
                    <DialogConfirm
                        {...this.state} 
                        onCloseDialog = { this.handleCloseDialog }
                        PayType = { this.handlePayType }
                        buttons = { [ this.createButton('COBRAR'),  this.createButton('ENDOSAR') ]}
                    />
                    <DialogOTP
                        {...this.state} 
                        onCloseDialogOTP = { this.handleCloseDialogOTP }
                        onAcceptClick = { this.receiveOTP }
                        // PayType = { this.handlePayType }
                    />
                    <DialogPrompt 
                        {...this.state} 
                        onCloseDialogPrompt = { this.handleCloseDialogPrompt }
                        onAcceptClickPrompt = { this.receivePrompt }
                    />
                    <CheckBookEndorseForm 
                        {...this.state}
                        onCloseDialogEndorse = { this.handleCloseDialogEndorse }
                        onAcceptClickEndorse = { this.receiveEndorse }
                        findCustomer = { this.findCustomer}
                    />
                </div>
    }
    render() {
        const { title } = this.props
        // const { alert } = this.state
        return (
            <div>
                <Dashboard
                    title= { title }
                    body = { this.renderBody() }
                    multiple = { false }
                />
            </div>
        )
    }
}


CheckbookPayContainer.propTypes = {
    user: PropTypes.object.isRequired,
    PaymentType: PropTypes.string.isRequired,
    checkbook: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired,
    devices: PropTypes.object.isRequired,
    customers: PropTypes.array.isRequired,
}



export default withRouter(connect(null, {
    getCheckbook,
    getCheckCharge,
    getCustomerData,
    setEndorse
} )(CheckbookPayContainer));
// export default CheckbookPayContainer